import React from 'react';
import ReactECharts from 'echarts-for-react';

export const EnergyGauge = ({ value }) => {
  const option = {
    series: [
      {
        type: 'gauge',
        startAngle: 180,
        endAngle: 0,
        center: ['50%', '75%'],
        radius: '90%',
        min: 0,
        max: 100,
        splitNumber: 8,
        axisLine: {
          lineStyle: { width: 6, color: [[0.25, '#2dd4bf'], [0.75, '#fbbf24'], [1, '#ef4444']] }
        },
        pointer: { icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z', length: '12%', width: 10, offsetCenter: [0, '-60%'], itemStyle: { color: 'auto' } },
        axisTick: { length: 12, lineStyle: { color: 'auto', width: 2 } },
        splitLine: { length: 20, lineStyle: { color: 'auto', width: 5 } },
        axisLabel: { color: '#94a3b8', distance: -40, fontSize: 10 },
        title: { offsetCenter: [0, '-20%'], fontSize: 14 },
        detail: { fontSize: 24, offsetCenter: [0, '0%'], valueAnimation: true, formatter: '{value} kW', color: '#e2e8f0' },
        data: [{ value: value, name: 'Current Usage' }]
      }
    ]
  };

  return <ReactECharts option={option} style={{ height: '200px', width: '100%' }} />;
};

export const UsageLineChart = () => {
  const option = {
    tooltip: { trigger: 'axis' },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', boundaryGap: false, data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], axisLabel: { color: '#94a3b8' } },
    yAxis: { type: 'value', axisLabel: { color: '#94a3b8' }, splitLine: { lineStyle: { color: '#334155' } } },
    series: [
      {
        name: 'Energy (kWh)',
        type: 'line',
        smooth: true,
        lineStyle: { color: '#2dd4bf', width: 3 },
        areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: 'rgba(45,212,191,0.5)' }, { offset: 1, color: 'rgba(45,212,191,0)' }] } },
        data: [12, 11, 14, 18, 15, 22, 20]
      }
    ]
  };
  return <ReactECharts option={option} style={{ height: '250px', width: '100%' }} />;
};